import { Component } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SharedService } from '../../../services/shared/shared.service';
import { JobService } from '../../../services/job/job.service';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { JobDto } from '../../../models/job-dto';
import Swal from 'sweetalert2';
import { AuthServiceService } from '../../../services/authService/auth-service.service';

@Component({
  selector: 'app-jobs',
  imports: [CommonModule, HeroComponent, RouterLink],
  templateUrl: './jobs.component.html',
  styleUrl: './jobs.component.css'
})
export class JobsComponent {

  jobs: JobDto[] = [];
  isLoggedIn=false;
  category: any;

  showSpinner = true;


  constructor(public sharedService: SharedService,
     private route: ActivatedRoute,
     private jobService:JobService,
     private firestoreService:FirestoreService,
     private router:Router,
     private authService:AuthServiceService
    
    ) { }

  ngOnInit() {
    this.getJobs(); // Initial load
    this.isUserLoggedIn();


    // Listen for route changes
    this.route.params.subscribe(params => {
      this.category = params['category'];
      this.getJobs();
    });


  }

  getJobs() {
    if (this.category) {
       this.getJobsByCategory();
    } else {
       this.getAllJob();
    }
  }
  
  getAllJob() {
    this.firestoreService.getAll('jobs').subscribe({
      next: (data) => {
        this.jobs = data;
          this.showSpinner = false;

      },
  
    });
  }
  getJobsByCategory(){
    this.jobService.getJobsByCategory(this.category).subscribe({
      next:res=>this.jobs=res
    })
  }


      isUserLoggedIn(){
        this.authService.isUserLoggedIn().subscribe({
          next:res=>{ this.isLoggedIn=res},
        })
      }
    
    
      navigateToApplicationComponent(jobId: string) {
        if (this.isLoggedIn) {
          this.router.navigateByUrl("/application/" + jobId);
        } else {
         Swal.fire({
  icon: 'warning',
  title: 'Nicht angemeldet',
  text: 'Sie müssen sich zuerst anmelden, um sich für diesen Job zu bewerben.',
  confirmButtonText: 'OK'
});
        }
    
  
  }

}
